<template>
  <div>    
    <div class="space-basic-bd1 mb-22 mt-16"></div>
    <a-form-item label="配置排序列" style="marginBottom: 0">
      <template v-for="(item, index) in orders">
        <a-select
          v-model="item.field"
          :filter-option="false"
          :allowClear="true"
          :placeholder="`请选择第${index + 1}排序列`"
          :key="index"
        >
          <a-select-option
            v-for="oitem in filterList"
            v-if="oitem.name != '对比日期'"
            :key="oitem.field"
            :value="oitem.field"
            :disabled="handleDisabledPrevChose(index, oitem)"
          >
            <div :title="oitem.desc">{{ oitem.name }}</div>
          </a-select-option>
        </a-select>
        <a-radio-group class="mt-6 mb-8" v-model="item.asc">
          <a-radio :value="true"> 正序 </a-radio>
          <a-radio :value="false"> 倒序 </a-radio>
        </a-radio-group>
      </template>
    </a-form-item>
    <div class="cont-add-order">
    <a-button class="mt--16" v-if="orders && orders.length <= 2" type="link" @click="addClick">
      <icon-font type="icon-plus-square"></icon-font>
      <span> 添加第{{orders.length +1}}顺序 </span>
    </a-button>
    </div>
    <a-button class="mt--16" v-if="orders && orders.length <= 3 && orders.length >= 2" type="link" @click="handleDel(orders.length)">
      <span> 删除 </span>
    </a-button>
  </div>
</template>
<script>
export default {
  props: ['orders', 'filterList'],
  methods: {
    // 表格排序列禁用功能
    handleDisabledPrevChose(index, item){
      if(index === 0){
        return false;
      }else if(index === 1){
        return this.orders[0].field === item.field
      }else if(index === 2){
        return this.orders[0].field === item.field || this.orders[1].field === item.field
      }
    },
    // 配置排序列
    handleDel(orderLen){
      let orders = this.$deepclone(this.orders)
      orders.splice(orderLen -1, 1)
      this.$emit('change', orders)
    },
    addClick() {
      let orders = this.$deepclone(this.orders)
      orders.push({
        field: undefined,
        asc: true,
      })
      this.$emit('change', orders)
    },
  }
}
</script>
<style scoped>
.cont-add-order{
  display: inline-block;
  width: 130px;
}
</style>